import {
  headline,
  spacer,
  text,
  field,
  button,
  voucher,
  wheel,
} from '@components/Widgets/_contentItems/all'
import { settings, styling } from '@components/Widgets/Templates/Base/_base'
import themes from '@components/Widgets/Templates/Themes/all'
import { type, maxWidth, position } from '@meta/widget/options'
import { tag, typeTag } from '@meta/widget/templates'

const info = {
  name: 'Spin to Win',
  templateID: '10',
  description: 'Engage your visitors with an interactive and fun "Spin to Win" widget. Users can enter their email and spin a digital wheel for a chance to win exciting prizes. Perfect for boosting user engagement and growing your email list.',
  tags: [typeTag.GAMIFICATION, tag.LEAD_GENERATION, tag.COUPONS_OFFERS],
}

const json = {
  id: 6452375,
  templateID: info.templateID,
  type: type.FORTUNE_WHEEL,
  name: info.name,
  theme: themes.ONVOCADO.theme,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.position = position.CENTER
    customSettings.ribbonColor = '#f8f9e8'
    customSettings.ribbonBgColor = '#000000'
    customSettings.wheel = (() => {
      const customWheel = JSON.parse(JSON.stringify(wheel))
       Object.assign(customWheel.styling, {
        color: '#f8f9e8',
        borderColor: 'rgb(0, 0, 0)',
        backgroundColor: '#0e2814',
        fontFamily: 'Anton',
        secondaryBackgroundColor: '#3e5344',
      })
      return customWheel
    })()
    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling } // Ensure we're working with a copy of the styling
    customStyling.maxWidth = maxWidth.EXTRA_LARGE
    customStyling.backgroundColor = '#def2a0'

    return customStyling
  })(),
  steps: [
    {
      id: 'sh2r48o',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Spin the wheel to win!'
          Object.assign(customHeadline.styling, {
            fontFamily: 'Anton',
            fontSize: '32px',
            fontWeight: 'bold',
            color: 'rgb(13, 40, 20)',
            textAlign: 'left',
          })
          return customHeadline
        })(),
        // text
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'Ready to test your fortune? Just enter your email, take a chance on our wheel, and you might just snag an amazing prize!'
          Object.assign(customText.styling, {
            color: 'rgb(24,23,26)',
            fontSize: '18px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '8px'
          return customSpacer
        })(),
        // field
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.title = 'Email'
          customField.content.placeholder = 'Your Email'
          Object.assign(customField.styling, {
            color: 'rgb(13, 40, 20)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: '#000000',
            borderWidth: '0px',
            borderRadius: '0px',
            backgroundColor: '#f8f9e8',
          })
          customField.settings.type = 'email'
          customField.settings.label = 'Email address'
          customField.settings.required = true

          return customField
        })(),
        // button
        (() => {
          const customBtn = JSON.parse(JSON.stringify(button))
          customBtn.content.text = 'Let\'s Spin'
          Object.assign(customBtn.styling, {
            color: '#f8f9e8',
            fontSize: '18px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgb(13, 40, 20)',
            borderWidth: '2px',
            borderRadius: '5px',
            justifyContent: 'center',
            backgroundColor: 'rgb(13, 40, 20)',
          })
          customBtn.settings.action = 'wheelSpin'
          customBtn.settings.backBtn = false
          return customBtn
        })(),
      ],
    },
    {
      id: '75jxe26',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Congratulations, you won!'
          Object.assign(customHeadline.styling, {
            fontFamily: 'Roboto',
            fontSize: '40px',
            fontWeight: 'bold',
            color: 'rgb(13, 40, 20)',
            textAlign: 'center',
          })
          return customHeadline
        })(),
        // text
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'Don\'t forget to copy your voucher code and use it at checkout!'
          Object.assign(customText.styling, {
            color: 'rgb(24,23,26)',
            fontSize: '18px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '8px'
          return customSpacer
        })(),
        // voucher
        (() => {
          const customVoucher = JSON.parse(JSON.stringify(voucher))
          customVoucher.content.text = 'VOUCHER CODE'
          Object.assign(customVoucher.styling, {
            color: 'rgb(24, 23, 26)',
            fontSize: '22px',
            textAlign: 'center',
            fontFamily: 'Roboto',
          })
          return customVoucher
        })(),
      ],
    },
  ],
}

export { json, info }
